import { AppState } from '../types/store';

export function getForgotUsername(state: AppState) {
  const params = new URLSearchParams(state.location?.search || '');
  return params.get('username') ?? state.forgot.username;
}

export function getForgotKind(state: AppState) {
  const params = new URLSearchParams(state.location?.search || '');

  // Form kind (password or username) is determined by query param
  // If a prefilled username param was found, we assume kind is "password"
  const kind = params.has('username') ? 'password' : (params.get('kind') ?? 'password');

  return ['password', 'username'].includes(kind) ? (kind as 'password' | 'username') : 'password';
}
